module.exports = __webpack_public_path__ + "img/shame.0b7a1d25.svg";